(function () {
  var previewObjectUrl = null;

  function revokePreviewObjectUrl() {
    if (!previewObjectUrl) return;

    URL.revokeObjectURL(previewObjectUrl);
    previewObjectUrl = null;
  }

  function initProfilePhotoPreview() {
    if (!$("body").hasClass("controller-public-hotsites-profiles")) return;

    var $input = $("#hotsite-profile-photo-input");
    if ($input.length === 0) return;

    $input.off("change.hotsiteProfilePhoto").on("change.hotsiteProfilePhoto", function (event) {
      if (event.target.files.length === 0) return;

      revokePreviewObjectUrl();
      previewObjectUrl = URL.createObjectURL(event.target.files[0]);

      var preview = document.getElementById("hotsite-profile-photo-preview");
      var initials = document.getElementById("hotsite-profile-photo-initials");
      preview.src = previewObjectUrl;
      preview.style.display = "";
      if (initials) initials.style.display = "none";
    });
  }

  $(document).on("turbolinks:load", initProfilePhotoPreview);
  $(document).on("turbolinks:before-cache", revokePreviewObjectUrl);
})();
